import * as arbitrum from "./arbitrum.json";
import * as ethereum from "./ethereum.json";
import * as polygon from "./polygon.json";

const tokens = { arbitrum, ethereum, polygon };
export default tokens;
